import { Injectable, InjectionToken } from "@angular/core";

export interface ITokenStorageService {
    getAccessToken(): string | null;
    setAccessToken(accessToken: string): void;
    removeAccessToken(): void;
    getRefreshToken(): string | null;
    setRefreshToken(refreshToken: string): void;
    removeRefreshToken(): void;
    clearAllTokens(): void;
}

@Injectable()
export class MemoryTokenService implements ITokenStorageService {
    private accessToken: string | null = null;
    private readonly REFRESH_TOKEN_KEY = 'refreshToken';

    getAccessToken(): string | null {
        return this.accessToken;
    }

    setAccessToken(accessToken: string): void {
        this.accessToken = accessToken;
    }

    removeAccessToken(): void {
        this.accessToken = null;
    }

    getRefreshToken(): string | null {
        return localStorage.getItem(this.REFRESH_TOKEN_KEY);
    }

    setRefreshToken(refreshToken: string): void {
        localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken);
    }

    removeRefreshToken(): void {
        localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    }

    clearAllTokens(): void {
        this.removeAccessToken();
        this.removeRefreshToken();
    }
}

export const TOKEN_STORAGE_SERVICE = new InjectionToken<ITokenStorageService>('TOKEN_STORAGE_SERVICE');